import React, {
  useContext,
} from 'react';
import {
  ThemeContext,
} from 'styled-components';
import {
  lighten,
} from 'polished';
import ReactSelect, { Props, Theme } from 'react-select';
import CreatableSelect from 'react-select/creatable';

interface SelectProps extends Props {
  theme?: any;
  // styles?: React.CSSProperties;
  creatable?: boolean;
}

const Select = ({
  theme = {},
  styles = {},
  creatable = false,
  ...rest
}: SelectProps) => {
  const tm = useContext(ThemeContext);
  const Component = creatable ? CreatableSelect : ReactSelect;
  const customStyles = {
    option: (provided: any) => ({
      ...provided,
      fontSize: '14px',
      lineHeight: '14px',
      cursor: 'pointer',
    }),
    ...styles,
  };

  return (
    <Component
      {...rest}
      theme={(initial: Theme) => ({
        ...initial,
        borderRadius: 0,
        colors: {
          ...initial.colors,
          primary: tm.colors.primary,
          primary25: lighten(0.3, tm.colors.primary),
          primary50: lighten(0.3, tm.colors.primary),
        },
        ...theme,
      })}
      styles={customStyles}
    />
  );
};

export default Select;
